import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import "./lmstableData.scss";
import { useNavigate } from "react-router-dom";
import { TableLoader } from "../../../library/common/Loader";
import {
  USER_ASSIGNED,
  USER_ASSIGNED_LESSON,
} from "../../../constant/routeContant";
import { ROW_PER_PAGE_SIZE } from "../../../constant/constant";
import NORow from "../../../library/custom/noRow/noRow";

const LmstableData = (props) => {
  const navigate = useNavigate();
  const LessonList = props?.lessionListDataAll;
  const CourseList = props?.courseListDataAll;
  const onPageChange = props.onPageChange;
  const isLoading = props.isLoading;
  const page = props.page ?? 0;
  const columns = props.columns;
  const handlePageSizeChange = props?.handlePageSizeChange;
  const pageSize = props?.pageSize;

  const handleOnCellClick = (params) => {
    let courseid = params?.id;
    let fieldId = params?.field;
    let name = params?.row?.course;
    let category = params?.row?.category;
    let finalid;
    if (fieldId === "totalCompletedByUser") {
      finalid = "true";
    } else if (fieldId === "totaleAssignedToUser") {
      finalid = "";
    } else {
      finalid = "false";
    }
    if (
      fieldId === "totalCompletedByUser" ||
      fieldId === "totaleAssignedToUser" ||
      fieldId === "totalNotCompletedByUser"
    ) {
      navigate(USER_ASSIGNED, {
        state: {
          courseId: courseid,
          fieldId: finalid,
          coursename: name,
          category: category,
          defaultCourseTab: props?.value,
        },
      });
    }
  };
  const handleOnCellLessonClick = (params) => {
    let lessonid = params?.id;
    let fieldId = params?.field;
    let name = params?.row?.lesson;
    let finalid;

    if (fieldId === "totalCompletedByUser") {
      finalid = "true";
    } else if (fieldId === "totaleAssignedToUser") {
      finalid = "";
    } else {
      finalid = "false";
    }
    if (
      fieldId === "totalCompletedByUser" ||
      fieldId === "totaleAssignedToUser" ||
      fieldId === "totalNotCompletedByUser"
    ) {
      navigate(USER_ASSIGNED_LESSON, {
        state: {
          lessonId: lessonid,
          fieldId: finalid,
          lessonname: name,
          defaultLessonTab: props?.value,
        },
      });
    }
  };
  return (
    <>
      <div
        className={
          props?.tableClass ? `tableData ${props.tableClass}` : "tableData"
        }
      >
        {CourseList ? (
          <DataGrid
            getRowId={(r) => r.id}
            rows={CourseList?.data?.courses ?? []}
            columns={columns}
            page={page}
            pageSize={pageSize}
            rowsPerPageOptions={ROW_PER_PAGE_SIZE}
            onPageSizeChange={handlePageSizeChange}
            onPageChange={onPageChange}
            paginationMode="server"
            rowCount={CourseList?.data?.noOfRecords ?? 0}
            IsReadOnly="True"
            backIconButtonProps={{ disabled: false }}
            loading={isLoading}
            getRowClassName={(params) => "customrowTable"}
            getColumnClassName={(params) => "customheaderTable"}
            headerClassName={"hideRightSeparator"}
            getEstimatedRowHeight={() => 100}
            getRowHeight={() => "auto"}
            onCellClick={handleOnCellClick}
            components={{
              LoadingOverlay: TableLoader,
              NoRowsOverlay: NORow,
            }}
            disableSelectionOnClick={true}
            disableColumnSelector={false}
            disableColumnFilter={false}
            disableColumnMenu={false}
          />
        ) : (
          <DataGrid
            getRowId={(r) => r.lessonId}
            rows={LessonList?.data?.lessons ?? []}
            columns={columns}
            page={page}
            pageSize={pageSize}
            rowsPerPageOptions={ROW_PER_PAGE_SIZE}
            onPageSizeChange={handlePageSizeChange}
            onPageChange={onPageChange}
            paginationMode="server"
            rowCount={LessonList?.data?.noOfRecords ?? 0}
            IsReadOnly="True"
            backIconButtonProps={{ disabled: false }}
            loading={isLoading}
            getRowClassName={(params) => "customrowTable"}
            getColumnClassName={(params) => "customheaderTable"}
            headerClassName={"hideRightSeparator"}
            getEstimatedRowHeight={() => 100}
            getRowHeight={() => "auto"}
            onCellClick={handleOnCellLessonClick}
            components={{
              LoadingOverlay: TableLoader,
              NoRowsOverlay: NORow,
            }}
            disableSelectionOnClick={true}
            disableColumnSelector={false}
            disableColumnFilter={false}
            disableColumnMenu={false}
            //disableColumnSelector={true}
          />
        )}
      </div>
    </>
  );
};

export default LmstableData;
